// FTU inbox empty state (US-037).
//
// Replaces the inbox middle-panel "no conversations" message during the FTU
// window so the user gets a "we're listening" cue instead of an inbox-zero
// hero. Pixel-faithful to `prototypes_and_docs/ls-ftu.jsx:110-155`.
//
// We compose the DS `EmptyState` primitive with a subtle pulse animation
// applied via tokens-only CSS (no inline hex literals).

import { Search } from 'lucide-react';

import { useT } from '@barel/i18n';
import { EmptyState } from '@barel/ui';

export function InboxEmptyState() {
  const t = useT('ftu');
  return (
    <EmptyState
      tone="accent"
      iconPulse
      media={<Search aria-hidden style={{ width: 28, height: 28 }} />}
      title={t('emptyInbox.title')}
      description={t('emptyInbox.subtitle')}
      data-region="ftu-inbox-empty"
    />
  );
}
